export default function Logo(props) {
    return (
        <img width={150} src="/assets/logo.png" alt="Example" />
    );
};